export const availableLanguages = [
    {
        key: 'nl',
        text: 'Nederlands',
    },
    {
        key: 'en',
        text: 'Engels',
    },
];
